<script></script>

<section id="roadmap">
  <div>
    <h2>THE ROADMAP</h2>
    <p>Let’s take a look at our roadmap and find all the Iced out Penguins on the run!</p>
    <ul>
      <li data-percentage="10%">Making our parents proud!</li>
      <li data-percentage="20%">Paying our college tuition.</li>
      <li data-percentage="40%">The Icy Penguin clothing line, will be released!</li>
      <li data-percentage="50%">Giving away 10 ULTRA RARE Icy Penguin NFT’s!</li>
      <li data-percentage="75%">Creating “Penguins From Outer Space” collection!</li>
      <li data-percentage="100%">Joining the metaverse</li>
    </ul>
  </div>
  <div>
    <img src="images/shirt.jpg" alt="Black shirt with a penguin NFT">
  </div>
</section>

<style scoped>

  section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    text-align: left;
  }

  section > div:last-child {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  h2 {
    font-size: 1.5rem;
    font-style: italic;
  }

  img {
    display: block;
    width: 75%;
    border-radius: 1rem;
  }

  p {
    margin-bottom: 3rem;
  }

  ul > li {
    list-style-type: none;
    margin-bottom: 3rem;
  }

  ul > li::before {
    width: 3em;
    display: inline-block;
    content: attr(data-percentage);
    color: #CC66FF;
    margin-right: 3em;
  }

  @media screen and (max-width: 60rem) {
    section {
      grid-template-columns: 1fr;
    }

    img {
      width: 100%;
    }

    section > div:last-child {
      justify-content: center;
    }
  }

  @media screen and (max-width: 35rem) {
    ul > li::before {
      display: block;
    }
  }

</style>